import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';

function Help() {
  return (
    <Container>
      <h1>Help & Support</h1>
      <Card className="mb-3">
        <Card.Header>How to Use This Tool</Card.Header>
        <Card.Body>
          <Card.Title>Input Autodetection</Card.Title>
          <Card.Text>
            Our tool automatically detects the type of code you enter into the search field. It supports several types of product codes:
            <ul>
              <li><strong>Tile SN</strong>: Usually starts with letters followed by numbers and ends with 'M', e.g., GP260M1234.</li>
              <li><strong>Module SN</strong>: Typically starts with letters, followed by numbers, and ends with 'S', e.g., GP260S1234.</li>
              <li><strong>Order Number</strong>: Can appear in several formats such as 2303010F or 1709-025F.</li>
            </ul>
            Just type the code into the search bar, and our system will figure out the type and fetch the corresponding data for you.
          </Card.Text>
        </Card.Body>
      </Card>
      
      <Card className="mb-3">
        <Card.Header>Code Locations</Card.Header>
        <Card.Body>
          <Card.Title>Understanding Code Locations</Card.Title>
          <Card.Text>
            Codes can be found on the physical LED panels. 
            <ul>
              <li><strong>Tile SN</strong>: Tile serial numbers have a barcode,and are typically located on the back of the frame of a panel on a non-removable section.</li>
              <li><strong>Module SN</strong>: Module serial numbers have a barcode, and can be found on the back of each individual LED module (LDM).</li>
              <li><strong>Order Number</strong>: Order numbers can be found on a sticker on the back of each individual module, typically near the module serial number barcode sticker..</li>
            </ul>
          </Card.Text>
        </Card.Body>
      </Card>

      <Card>
        <Card.Header>Contact Us</Card.Header>
        <Card.Body>
          <Card.Title>Need More Help?</Card.Title>
          <Card.Text>
            If you need further assistance, please do not hesitate to contact our support team.
            <p>Email us at: <a href="mailto:ussupport@roevisual.com">ussupport@roevisual.com</a></p>
          </Card.Text>
          <Button href="mailto:ussupport@roevisual.com" variant="primary">Send Email</Button>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default Help;
